import { Box, CircularProgress, Grid, styled } from "@mui/material";
import React, { useEffect, useState } from "react";

import { LoadingState } from "../../../model/LoadingState";
import { GetOfferDetailsResponse, ResponseStatus } from "../../../model/MortgageExtensionModel";
import { useMortgageClient } from "../../../services/mortgage-client/MortgageClientContext";
import AddressInfo from "../../address-info/AddressInfo";
import ErrorMessage from "../../feedback/ErrorMessage";
import NoMortgagesMessage from "../../feedback/NoMortgagesMessage";
import OverviewDetails from "./OverviewDetails";

/**
 * A screen which displays all fixed-rate mortgages of a currently logged-in user.
 */
const OverviewScreen = () => {
    const mortgageClient = useMortgageClient();
    const [offerDetails, setOfferDetails] = useState<GetOfferDetailsResponse>();
    const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.Loading);

    useEffect(() => {
        loadOffers();
    }, []);

    async function loadOffers() {
        try {
            const offers = await mortgageClient.fetchMortgages();
            setOfferDetails(offers);
            if (offers.operationStatus?.status === ResponseStatus.Failed) {
                setLoadingState(LoadingState.Failed);
            } else {
                setLoadingState(LoadingState.Success);
            }
        } catch (e) {
            console.error(e);
            setLoadingState(LoadingState.Failed);
        }
    }

    function noMortgagesLoaded(): boolean {
        return loadingState === LoadingState.Success && (offerDetails?.mortgages?.length ?? 0) === 0;
    }

    return (
        <Grid container data-cy={"overview-screen"}>
            <Grid item sm={0} md={2} lg={2}></Grid>
            <Grid item sm={12} md={8} lg={8}>
                {(offerDetails?.mortgages ?? []).map((mortgage) => (
                    <Box data-cy={"overview-details"} key={mortgage.id} mb={"64px"}>
                        <Box marginLeft={"7px"} data-cy={"address-text"}>
                            <AddressInfo selectedMortgage={mortgage} />
                        </Box>
                        <OverviewDetails mortgage={mortgage} />
                    </Box>
                ))}
                {loadingState === LoadingState.Loading && (
                    <Box data-cy={"loading"} sx={{ display: "flex", justifyContent: "center" }}>
                        <CircularProgress />
                    </Box>
                )}
                {loadingState === LoadingState.Failed && (
                    <Box>
                        <ErrorMessage />
                    </Box>
                )}
                {noMortgagesLoaded() && (
                    <Box>
                        <NoMortgagesMessage />
                    </Box>
                )}
            </Grid>
            <Grid item sm={0} md={2} lg={2}></Grid>
        </Grid>
    );
};
export default OverviewScreen;
